import React from "react";

const ProductProfileCard = ({ product }) => {
        const primaryImage = product.images?.find(img => img.is_primary === 1) || product.images?.[0];

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0">PRODUCT PROFILE</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3 text-center">
                    {primaryImage?.image_url ? (
                            <img 
                                // src={primaryImage.image_url} 
                                 src={`https://crm.a2logicgroup.com/${primaryImage.image_url}`}
                                alt={primaryImage.alt_text || product.name}
                                className="product-image img-fluid rounded"
                                style={{ maxHeight: "200px", objectFit: "contain" }}
                            />
                        ) : (
                            <div className="product-image-placeholder">
                                <i className="fa fa-image fa-4x text-muted"></i>
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <h3 className="fw-bold">{product.product_name}</h3>
                        <span className={`badge ${product.status === 1 ? 'bg-success' : 'bg-danger'} mb-3`}>
                            {product.status === 1 ? ' Active' : 'Inactive'}
                        </span>
                     <div className="product-details-grid">
                            <div><strong>Product ID:</strong> {product.name || '-'}</div>
                            <div><strong>SKU:</strong> {product.sku || '-'}</div>
                            <div><strong>Barcode:</strong> {product.barcode || '-'}</div>
                            <div><strong>Brand:</strong> {product.brands_details?.name || '-'}</div>
                            <div><strong>Category:</strong> {product.category_details?.name || '-'}</div>
                            <div><strong>SubCategory:</strong> {product.subcategory_details?.name || '-'}</div>
                            <div><strong>Weight:</strong> {product.weight || '-'} {product.dimensions_unit || ''}</div>
                        </div>
                    </div>
                   <div className="col-md-3 text-end">
                        <div className="pricing-info">
                            <h3 className="text-primary">₹{parseFloat(product.price).toLocaleString() || '0'}</h3>
                            <small className="text-muted text-decoration-line-through">
                                MRP ₹{parseFloat(product.mrp).toLocaleString() || '0'}
                            </small>
                            <br />
                            <small className="text-muted">
                                Cost ₹{parseFloat(product.cost_price).toLocaleString() || '0'}
                            </small>
                            {parseFloat(product.discount_percent) > 0 && (
                                <div className="badge bg-success mt-1">
                                    {product.discount_percent}% OFF
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductProfileCard;